import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { translate } from "react-i18next";
import { Button, Form, FormGroup, Alert, timeoutsShape } from "reactstrap";
import { InputText, Validations, Loading, Vmodal } from "../components";
import { USER_LANG, statusEnum } from "../actions/constant";
import forgotPasswordResetActions from "../actions/forgotPasswordResetActions";
import i18n from "../i18n";
import "./styles/homePage.css";
import "./styles/authModern.css";

// password validation
const required = Validations.required;
const min8 = Validations.min8;
const minOneUppercase = Validations.min_one_uppercase;
const minOneNumber = Validations.min_one_number;
const minOneSpecial = Validations.min_one_special;

// new custom pass checker
let min8Checker;
let minOneUppercaseChecker;
let minOneLowercaseChecker;
let minOneNumberChecker;
let minOneSpecialChecker;

let customPassChecker = (value) => {
  min8Checker = value && Validations.min8(value) ? false : true;
  minOneUppercaseChecker = Validations.min_one_uppercase(value) ? false : true;
  minOneLowercaseChecker = Validations.min_one_lowercase(value) ? false : true;
  minOneNumberChecker = Validations.min_one_number(value) ? false : true;
  minOneSpecialChecker = Validations.min_one_special(value) ? false : true;
};

let ForgotPasswordForm = (props) => {
  const { t } = props;
  const handleCancel = () => {
    window.location.href = "/";
  };

  return (
    <div className="passwordReset">
      <Form onSubmit={props.handleSubmit}>
        <FormGroup>
          <Field
            component={InputText}
            type={props.showResetPassword ? "text" : "password"}
            name="new_password"
            placeholder={t("reset.NEW_PASSWORD")}
            onChange={props.passValidator}
            style={{ paddingRight: 36 }}
          />
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div></div>
            <div
              style={{
                marginTop: "-25px",
                display: "flex",
                cursor: "pointer",
                marginRight: "10px",
                width: "20px",
                height: "25px",
              }}
              onClick={props.showResPass}
            >
              <i
                className={
                  props.showResetPassword ? "far fa-eye" : "far fa-eye-slash"
                }
                style={{ color: "#077bff" }}
              />
            </div>
          </div>
          {props.newPasswordValidator && (
            <div className="invalid-feedback">
              <span
                style={{
                  color: "#212529",
                }}
              >
                {i18n.t("validations.VALIDATE_PASSWORD")}
              </span>
              <span
                style={{
                  color:
                    props.newPasswordValidator && min8Checker
                      ? "#008000"
                      : "#DC3545",
                }}
              >
                {i18n.t("validations.VALIDATE_MIN_8")}
              </span>
              <span
                style={{
                  color:
                    props.newPasswordValidator && minOneUppercaseChecker
                      ? "#008000"
                      : "#DC3545",
                }}
              >
                {i18n.t("validations.VALIDATE_MIN_UPPERCASE")}
              </span>
              <span
                style={{
                  color:
                    props.newPasswordValidator && minOneLowercaseChecker
                      ? "#008000"
                      : "#DC3545",
                }}
              >
                {i18n.t("validations.VALIDATE_MIN_LOWERCASE")}
              </span>
              <span
                style={{
                  color:
                    props.newPasswordValidator && minOneNumberChecker
                      ? "#008000"
                      : "#DC3545",
                }}
              >
                {i18n.t("validations.VALIDATE_MIN_NUMBER")}
              </span>
              <span
                style={{
                  color:
                    props.newPasswordValidator && minOneSpecialChecker
                      ? "#008000"
                      : "#DC3545",
                }}
              >
                {i18n.t("validations.VALIDATE_MIN_SPECIAL_CHARACTER")}
              </span>
            </div>
          )}
        </FormGroup>
        <FormGroup>
          <Field
            component={InputText}
            type={props.showResetPasswordConfirm ? "text" : "password"}
            name="confirm_password"
            placeholder={t("reset.NEW_PASSWORD_CONFIRM")}
            onChange={props.checkConfirmPass}
            invalid={
              props.newPasswordValidator !== props.confirmPasswordValidator
                ? true
                : false
            }
            style={{ paddingRight: 36 }}
          />
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div></div>
            <div
              style={{
                marginTop: "-25px",
                display: "flex",
                cursor: "pointer",
                marginRight: "10px",
                width: "20px",
                height: "25px",
              }}
              onClick={props.showResPassConfirm}
            >
              <i
                className={
                  props.showResetPasswordConfirm
                    ? "far fa-eye"
                    : "far fa-eye-slash"
                }
                style={{
                  color: "#077bff",
                }}
              />
            </div>
          </div>
          {props.confirmPasswordValidator &&
            props.newPasswordValidator != props.confirmPasswordValidator ? (
            <div className="invalid-feedback">
              {t("reset.PASSWORD_CONFIRM_NOT_MATCH")}
            </div>
          ) : (
            ""
          )}
        </FormGroup>
        <div className="submit2 row justify-content-between">
          <div className="col">
            <Button
              className="button-submit"
              color="primary"
              onClick={handleCancel}
            >
              {t("general.CANCEL")}
            </Button>
          </div>
          <div className="col">
            <Button
              className="button-submit"
              color="primary"
              disabled={
                min8Checker &&
                  minOneLowercaseChecker &&
                  minOneNumberChecker &&
                  minOneSpecialChecker &&
                  minOneUppercaseChecker &&
                  props.newPasswordValidator === props.confirmPasswordValidator
                  ? false
                  : true
              }
            >
              {t("general.SUBMIT")}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

ForgotPasswordForm = reduxForm({
  form: "formForgotPassword",
})(ForgotPasswordForm);

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResetPassword: false,
      showResetPasswordConfirm: false,
      new_passwordValidator: "",
      confirm_passwordValidator: "",
      user: "",
      key: "",
      lang: "",
    };
  }
  passValidator(e) {
    this.setState({
      new_passwordValidator: e.currentTarget.value,
    });
    customPassChecker(e.currentTarget.value);
  }
  checkConfirmPass(e) {
    this.setState({
      confirm_passwordValidator: e.currentTarget.value,
    });
  }
  showResPass() {
    this.setState({
      showResetPassword: !this.state.showResetPassword,
    });
  }
  showResPassConfirm() {
    this.setState({
      showResetPasswordConfirm: !this.state.showResetPasswordConfirm,
    });
  }
  componentDidMount() {
    const { user: email, key, lang } = this.props.match.params; // :user / :key / :lang (ID)
    const entry = USER_LANG.find(m => String(m.value) === String(lang));
    const langCode = entry && entry.code; // <-- i18n code (e.g. 'en-US', 'zh-CN'), NOT the ID

    if (langCode) {
      // mirror HomePage behavior: set i18n  persist for other tabs/new windows
      i18n.changeLanguage(langCode);
      try {
        localStorage.setItem("i18nextLng", langCode);
        sessionStorage.setItem("i18nextLng", langCode);
      } catch (e) {}
    }
    this.setState({ email, key, lang });
  }
  componentWillMount() {
    this.props.setDefaultState();
  }
  handleSubmit(values) {
    const user = values;
    user.step = 2;
    user.email = this.state.email;
    user.key = this.state.key;
    this.props.forgotPasswordResetSubmit(user);
  }

  cancelClicked() {
    window.location.reload();
    localStorage.setItem("i18nextLng", i18n.language);
  }

  render() {
    const { isLoading, t } = this.props;
    const { lang } = this.state;
    return (
      <div className="auth-modern">
        <Loading isLoading={isLoading} />
        <Vmodal
          displayStatus={this.props.submit}
          data={
            <div>
              <h4>{t("reset.RESET_SUCCESS_TITLE")}</h4>
              <p>{t("reset.RESET_SUCCESS_TEXT")}</p>
            </div>
          }
          closeFunc={() => {
            this.props.closeModal();
            // window.location.href = "/" + "?"  lang;
            const entry = USER_LANG.find(m => String(m.value) === String(this.state.lang));
            const code  = entry && entry.code;
            const url   = new URL("/", window.location.origin);
            // carry both, for backend and i18next query detector (if enabled later)
            if (this.state.lang) url.searchParams.set("lang", this.state.lang); // backend ID
            if (code)            url.searchParams.set("lng",  code);            // i18n code
            window.location.href = url.toString();
          }}
          timedClose={2000}
        />
        <div className="row justify-content-center">
          <div className="login-box col-lg-4 col-md-6">
            <p className="forgot-title">{t("forgot.STEP2TITLE")}</p>

            <ForgotPasswordForm
              key={i18n.language}
              showResetPassword={this.state.showResetPassword}
              showResetPasswordConfirm={this.state.showResetPasswordConfirm}
              newPasswordValidator={this.state.new_passwordValidator}
              confirmPasswordValidator={this.state.confirm_passwordValidator}
              showResPass={this.showResPass.bind(this)}
              showResPassConfirm={this.showResPassConfirm.bind(this)}
              onSubmit={this.handleSubmit.bind(this)}
              onCancel={this.cancelClicked.bind(this)}
              passValidator={this.passValidator.bind(this)}
              checkConfirmPass={this.checkConfirmPass.bind(this)}
              t={t}
            />
          </div>
        </div>
      </div>
    );
  }
}

ForgotPassword = translate("translations")(ForgotPassword);

const mapStateToProps = (state) => ({ ...state.forgotPasswordReset });

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...forgotPasswordResetActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/pages/ForgotPasswordReset.js